import {ErrorHandler, inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {BaseService} from "./base.service";
import {LocalStorageService} from "./local-storage.service";
import { DeviceService } from './device.service';
import * as packageData from '../../../package.json';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService extends BaseService implements ErrorHandler {

  private http = inject(HttpClient);
  private localStorage: LocalStorageService = inject(LocalStorageService);
  private deviceService = inject(DeviceService);

  private packageData: any = packageData;
  private isSending = false;

  // localStorage спільний з новим фронтом (v2) на тому ж домені - там лежать email
  // і стан авторизації користувача. У лог шлемо лише ключі старого кабінету.
  private readonly logStorageKeys = ['delivery_id', 'currencies', 'searchMode'];

  private getOwnStorage(): string {
    const storage: {[key: string]: string} = {};

    this.logStorageKeys.forEach((key) => {
      const value = this.localStorage.get(key);

      if (value !== null) {
        storage[key] = value;
      }
    });

    return JSON.stringify(storage);
  }

  handleError(error: any): void {
    console.error('Глобальная ошибка Angular:', error);

    if (this.isSending) return;
    this.isSending = true;

    try {
      const errorMessage = error?.message || error?.toString();
      const deviceInfo = this.deviceService.getDeviceInfo();

      this.http.post(this.apiRoot + 'header/error_handler', {
        error: errorMessage,
        url: window.location.href,
        timestamp: new Date().toISOString(),
        localStorage: this.getOwnStorage(),
        version: this.packageData.version,
        deviceInfo: deviceInfo,
      }).subscribe({
        next: () => {
          console.log('Ошибка отправлена на сервер');
          this.isSending = false;
        },
        error: (e) => {
          console.error('Ошибка при отправке лога', e);
          this.isSending = false;
        }
      });
    } catch (e) {
      console.error('Ошибка в error-handler:', e);
      this.isSending = false;
    }
  }
}
